import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { SpaceSection } from '../../SpaceSection';
import { AdditionalParametersList } from '../../../AdditionalParametersList';
import { AdditionalParameter } from '../../../../hooks/useAdditionalParameters';
import { SectionTitle } from '../CurrentItemSections/styled';

interface AdditionalParametersSectionProps {
  parameters?: AdditionalParameter[] | null;
}

const AdditionalParametersSectionComponent: React.FC<
  AdditionalParametersSectionProps
> = ({ parameters }) => {
  const { t } = useTranslation();

  if (!parameters?.length) return null;

  return (
    <SpaceSection>
      <div data-cy="cur-item-additional-parameters">
        <SectionTitle tag="title_3_new">
          {t('pages.current_item.additional_information')}
        </SectionTitle>

        <AdditionalParametersList
          parameters={parameters}
          cypress="cur-item-additional-parameters-list"
        />
      </div>
    </SpaceSection>
  );
};

export const AdditionalParametersSection = memo(
  AdditionalParametersSectionComponent
);
